import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

import logo from '../../../assets/plates/header-logo.png';
import { C, MARGIN } from './pdfTheme';

const chrome = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    paddingBottom: 12,
    marginBottom: 14,
    borderBottomWidth: 0.75,
    borderBottomColor: C.line,
  },
  brand: { flexDirection: 'row', alignItems: 'center', marginBottom: 8 },
  logo: { width: 16, height: 16, marginRight: 6 },
  brandText: { fontSize: 8, fontWeight: 700, color: C.greenInk, letterSpacing: 0.4, textTransform: 'uppercase' },
  lead: { flex: 1, paddingRight: 16 },
  titleRow: { flexDirection: 'row', alignItems: 'baseline' },
  title: { fontSize: 24, fontWeight: 900, letterSpacing: -0.6, lineHeight: 1.05 },
  subtitle: { fontSize: 12, color: C.ink2, marginLeft: 10 },
  subtitleBelow: { fontSize: 12, color: C.ink2, marginTop: 3 },
  meta: { fontSize: 8.5, color: C.ink3, marginTop: 4 },
  fields: { flexDirection: 'row' },
  field: { width: 150, marginLeft: 18 },
  fieldNarrow: { width: 110, marginLeft: 14 },
  fieldLabel: { fontSize: 7, fontWeight: 700, color: C.ink3, letterSpacing: 0.4, textTransform: 'uppercase', marginBottom: 14 },
  fieldLine: { borderBottomWidth: 0.75, borderBottomColor: C.field },
  footer: {
    position: 'absolute',
    left: MARGIN,
    right: MARGIN,
    bottom: MARGIN - 6,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 8,
    borderTopWidth: 0.75,
    borderTopColor: C.line,
    fontSize: 7.5,
    color: C.ink3,
  },
  footerBrand: { fontWeight: 700, color: C.greenInk },
});

// Brand, title, subtitle and meta on the left; write-in fields (name, start date) on the right.
// narrow: portrait pages, where the subtitle goes under the title and the fields shrink
export const SheetHeader = ({ brand, title, subtitle, meta, fields = [], fixed = false, narrow = false }) => (
  <View style={chrome.header} fixed={fixed}>
    <View style={chrome.lead}>
      <View style={chrome.brand}>
        <Image src={logo} style={chrome.logo} />
        <Text style={chrome.brandText}>{brand}</Text>
      </View>
      <View style={chrome.titleRow}>
        <Text style={chrome.title}>{title}</Text>
        {subtitle && !narrow ? <Text style={chrome.subtitle}>{subtitle}</Text> : null}
      </View>
      {subtitle && narrow ? <Text style={chrome.subtitleBelow}>{subtitle}</Text> : null}
      {meta ? <Text style={chrome.meta}>{meta}</Text> : null}
    </View>
    <View style={chrome.fields}>
      {fields.map((label) => (
        <View key={label} style={narrow ? chrome.fieldNarrow : chrome.field}>
          <Text style={chrome.fieldLabel}>{label}</Text>
          <View style={chrome.fieldLine} />
        </View>
      ))}
    </View>
  </View>
);

export const SheetFooter = ({ site, generated, page }) => (
  <View style={chrome.footer} fixed>
    <Text style={chrome.footerBrand}>{site}</Text>
    <Text>{generated}</Text>
    <Text render={({ pageNumber, totalPages }) => page(pageNumber, totalPages)} />
  </View>
);
